//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MainImage from '~/components/atoms/Editorial/MainImage.vue';
import PlusDisplayLayer from '~/components/atoms/Editorial/PlusDisplayLayer.vue';
import ImageLegend from '~/components/atoms/Editorial/ImageLegend.vue';
export default {
  name: 'ImageLayerLegend',
  components: {
    MainImage,
    PlusDisplayLayer,
    ImageLegend
  },
  props: {
    context: {
      type: String,
      required: true
    },
    reference: {
      type: String,
      required: true
    },
    layer: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    ratio: {
      type: String,
      default: ''
    },
    legend: {
      type: Array,
      required: true
    },
    negativeText: {
      type: Boolean,
      default: true
    }
  }
};